export default "__VITE_ASSET__DOWt4Pol__"